import { jsxs as f, jsx as t } from "react/jsx-runtime";
import { I as s, f as p } from "../../vendor--aJiswR_.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as x } from "../../utils/omitStyleRenderProps/index.js";
import { FieldDescription as h } from "../FieldDescription/index.js";
import { FieldError as F } from "../FieldError/index.js";
import { FieldLabel as _ } from "../FieldLabel/index.js";
import { Input as u } from "../Input/index.js";
import '../../assets/index23.css';const z = "_textField_1i6z2_1", b = "_horizontal_1i6z2_21", W = "_fullWidth_1i6z2_40", e = {
  textField: z,
  horizontal: b,
  fullWidth: W
};
function P({
  label: l,
  description: r,
  errorMessage: d,
  type: a = "text",
  inputMode: m = "text",
  enterKeyHint: n = "enter",
  autoComplete: $,
  fullWidth: c = !1,
  horizontal: i = !1,
  ...o
}) {
  return /* @__PURE__ */ f(
    s,
    {
      ...x(o),
      type: a,
      inputMode: m,
      enterKeyHint: n,
      className: p(e.textField, {
        [e.fullWidth]: c || i,
        [e.horizontal]: i
      }),
      "data-component": "TextField",
      children: [
        /* @__PURE__ */ t(_, { children: l }),
        /* @__PURE__ */ t(u, { "aria-label": o["aria-label"] }),
        /* @__PURE__ */ t(h, { children: r }),
        /* @__PURE__ */ t(F, { children: d })
      ]
    }
  );
}
export {
  P as TextField
};
//# sourceMappingURL=index.js.map
